export default {
  HIGHLIGHT_ANNOTATION(
    state: any,
    { type, annotationId }: { type: 'hover' | 'click'; annotationId: number },
  ) {
    state.highlightedAnnotation = {
      ...state.highlightedAnnotation,
      [type]:
        state.highlightedAnnotation[type] == annotationId
          ? undefined
          : annotationId,
    };
  },
  TOGGLE_SKILL_DESCRIPTION(state: any, event: Event) {
    const previousState = state.skillDescription;
    const element = event.target as HTMLElement;
    const click = !!(
      +previousState.click ^ +['touchstart', 'click'].includes(event.type)
    ); // XOR
    const hover = event.type === 'mouseenter';
    const active = click || hover;
    let title, description;
    let position = {};
    if (active) {
      (title = element.innerText),
        (description = (element.attributes as any).skilldescription.value);
      position = {
        top: element.offsetTop + element.offsetHeight,
        left: element.offsetLeft + element.offsetWidth,
      };
    }
    state.skillDescription = {
      hover,
      click,
      title,
      description,
      position,
    };
  },
};
